import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../../model/local-storage-keys.model';
import { AppRecentApiService } from './app-recent-api.service';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Observable, of, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AppRecentService {

	newRecentApps: { [userEntityId: number]: string[] } = {}
	public appsUpdated$ = new Subject<void>();

	constructor(protected appRecentApiService: AppRecentApiService) {
		this.cleanOldStorageFormat()
	}

	//TODO: remove this method after some time
	private cleanOldStorageFormat(): void {
		const data = localStorage.getItem("recentApps")
		if (data) {
			localStorage.removeItem("recentApps")
		}
	}

	private loadStoredApps(): void {
		const data = localStorage.getItem(LocalStorageKeys.NewRecentApps)
		this.newRecentApps = data ? JSON.parse(data) : {}
	}

	putApp(code: string, userEntityId: number): Observable<void> {
		return this.appRecentApiService.putApp(code).pipe(
			tap(response => {
				if (response.ok) {
					this.loadStoredApps();

					if (!this.newRecentApps[userEntityId]) {
						this.newRecentApps[userEntityId] = []
					}

					this.newRecentApps[userEntityId] = this.newRecentApps[userEntityId].filter(p => p != code)
					this.newRecentApps[userEntityId] = [code].concat(this.newRecentApps[userEntityId])
					if (this.newRecentApps[userEntityId].length > 5) {
						this.newRecentApps[userEntityId].pop()
					}
					localStorage.setItem(LocalStorageKeys.NewRecentApps, JSON.stringify(this.newRecentApps))
					this.appsUpdated$.next();
				}
			}),
			map(() => undefined)
		)

	}

	getAppsCodes(userEntityId: number): string[] {
		this.loadStoredApps()
		return this.newRecentApps[userEntityId] || []
	}

	public syncAppsCodes(userEntityId: number): Observable<void> {
		const sessionKey = `appsSynced_${userEntityId}`;
		if (sessionStorage.getItem(sessionKey)) {
			return of(undefined);
		}

		return this.appRecentApiService.getAppsCodesByUserEntity().pipe(
			switchMap(response => {
				// Delete this condition after some time, this is to persist actual localstorage data to backend, in case there are users with the old version of the frontend
				if (response.entity.length === 0) {
					const storedApps = this.getAppsCodes(userEntityId);
					if (storedApps.length > 0) {
						return this.appRecentApiService.putAppsCodesByUserEntity(storedApps).pipe(
							tap(() => sessionStorage.setItem(sessionKey, 'true')),
							map(() => undefined)
						);
					} else {
						this.newRecentApps[userEntityId] = [];
						localStorage.setItem(LocalStorageKeys.NewRecentApps, JSON.stringify(this.newRecentApps));
						sessionStorage.setItem(sessionKey, 'true');
						this.appsUpdated$.next();
						return of(undefined);
					}
				}
				const codes = response.entity.map(e => e.appCode);
				this.loadStoredApps();
				this.newRecentApps[userEntityId] = codes;
				localStorage.setItem(LocalStorageKeys.NewRecentApps, JSON.stringify(this.newRecentApps));
				sessionStorage.setItem(sessionKey, 'true');
				this.appsUpdated$.next();
				return of(undefined);
			}),
			catchError(() => {
				this.loadStoredApps();
				return of(undefined);
			})
		);
	}
	
}


